<template>
  <div class="pa-20">
    <h1 class="has-text-weight-bold is-size-4 has-text-primary pl-20 mb-20">
      {{$t('recapBudgetaire.titreRecap')}}
    </h1>
    <app-tableau-recap
      :recom-devis="recomDevis"
      :panneaux="panneaux"
      :societe="societe"
      :libelle="''">
    </app-tableau-recap>
  </div>
</template>

<script>
import TabRecapBudgAnnuel from './tabRecapBudgAnnuel';

export default {
  props: {
    societe: Object,
    recomDevis: Object,
    panneaux: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    appTableauRecap : TabRecapBudgAnnuel,
  },
};
</script>
